export default {
  common: {
    login: "Connexion",
    userName: "Nom d'utilisateur",
    password: "Mot de passe",
    rememberPassword: "Se souvenir de moi",
    modifyPassword: "Modifier le mot de passe",
    accountRegister: "Inscription du compte",
    pleaseInput: "Veuillez saisir",
    loginErrorCheckNamePassword: "Échec de la connexion, veuillez vérifier le nom d'utilisateur et le mot de passe",
    guest: "Invité",
    superAdmin: "Super administrateur",
    logOut: "Se déconnecter",
    inputUserName: "Entrer le nom d'utilisateur",
    inputPassword: "Entrer le mot de passe",
    modifySuccessfully: "Modifier le mot de passe avec succès!",

    using: "Utilisation",
    toLogin: "pour se connecter",
    noOktaLoginUrl: "Aucune URL de connexion OKTA"
  },
  register: {
    email: "E-mail",
    confirmPassword: "Confirmer le mot de passe",
    register: "S'inscrire",
    emailRequire: "L'e-mail est requis",
    passwordRequire: "Le mot de passe est requis",
    confirmPasswordRequire: "La confirmation du mot de passe est requise",
    passwordInconsistency: "Incohérence du mot de passe",
    registeredSuccessfully: "Inscription réussie !",
    jumpToLoginPage: "Le système vous redirigera automatiquement vers la page de connexion.",
    contactAdminActivate: "Veuillez contacter votre administrateur pour activer votre compte avant de vous connecter."
  },
  my: {
    about: "À propos",
    language: "Langue"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/fr.js